module.exports = __webpack_public_path__ + "static/media/seriousSeverePain.070e9014.mp3";